<style scoped>
    .course-chart-container{
        position: relative;
    }
    .chart{
        height: 400px;
    }
</style>
<template>
  <div class="course-chart-container">
    <Checkbox
      :indeterminate="course_indeterminate"
      :value="checked_all_course"
      @click.prevent.native="handleCheckAllCourse"
    >
      <span>课程全选</span>
    </Checkbox>
    <CheckboxGroup
      v-model="params.course_ids"
      @on-change="checkCourseChange"
    >
      <Checkbox
        v-for="course in courses"
        :key="course.id"
        :label="course.id"
      >
        <span>{{ course.name }}</span>
      </Checkbox>
    </CheckboxGroup>
    <div class="hr" />
    <CheckboxGroup
      v-model="params.course_data_type_ids"
      @on-change="checkTypeChange"
    >
      <Checkbox
        v-for="type in course_data_types"
        :key="type.id"
        :label="type.id"
      >
        <span>{{ type.name }}</span><Tooltip
          v-if="type.name_tip"
          placement="top"
          transfer
        >
          <Icon type="md-help-circle" />
          <div
            slot="content"
            @click.stop=""
          >
            {{ type.name_tip }}
          </div>
        </Tooltip>
      </Checkbox>
      <span
        class="color-warning"
        style="font-size: 12px;"
      >最多同时选择3项</span>
    </CheckboxGroup>
    <div class="hr" />
    <div
      ref="chart"
      class="chart"
    />
    <Spin
      v-if="loading"
      fix
    />
  </div>
</template>
<script route="/course_report/chart">
  import echarts from 'echarts';
  export default {
    /* router_info_start */
    router_info:{
      path: '/course_report/chart',
      noChkout: true,
    },
    /* router_info_end */
    data() {
      return {
        params: {
          course_ids: [],
          course_data_type_ids: []
        },
        courses: [],
        course_hash: {},
        course_data_types: [],
        course_data_type_hash: {},
        course_indeterminate: false,
        checked_all_course: true,
        loading: false,
        max_term: 0,
        chart_type: 'line'
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      this.initChart();
      this.getCoursesAndTypes();
    },
    methods: {
      initChart() {
        this.chart = echarts.init(this.$refs.chart);
      },
      getCoursesAndTypes() {
        Util.ajax.get(Util.api.chart_courses_and_types).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.courses = data.courses;
            this.genCourseHash();
            this.course_data_types = data.course_data_types;
            this.genCourseDataTypeHash();
            this.params.course_ids = this.getAllCourseIds();
            this.params.course_data_type_ids = [this.course_data_types[0].id];
            this.updateData();
          } else {
            //失败
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      genCourseHash() {
        this.courses.forEach((course) => {
          this.course_hash[course.id] = course;
        });
      },
      genCourseDataTypeHash() {
        this.course_data_types.forEach((type) => {
          this.course_data_type_hash[type.id] = type;
        });
      },
      updateData() {
        if (!this.params.course_ids.length || !this.params.course_data_type_ids.length) {
          return;
        }
        this.loading = true;
        Util.ajax.get(Util.api.course_chart_data, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            this.max_term = data.max_term;
            this.genChartOption(data.course_datas);
          } else {
            //失败
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.loading = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      genChartOption(course_datas) {
        const course_type_hash = {};
        course_datas.forEach((cd) => {
          const course = this.course_hash[cd.course_id];
          const type = this.course_data_type_hash[cd.course_data_type_id];
          const key = `c${course.id}t${type.id}`;
          if (!course_type_hash[key]) {
            let series_name = `${course.name}-${type.name}`;
            if (type.data_type === 'percent') {
              series_name += '%';
            }
            // serie
            course_type_hash[key] = {
              name: series_name,
              type: this.chart_type,
              //smooth: true,
              data: []
            };
          }
          let value = 0;
          if (type.data_type === 'decimal' || type.data_type === 'percent') {
            value = parseFloat(cd.number_value);
          } else {
            value = parseInt(cd.number_value);
          }
          course_type_hash[key]['data'][cd.term - 1] = value;
        });
        // 生成chart option
        const series = [];
        const legend = {data: []};
        Object.values(course_type_hash).forEach((serie) => {
          series.push(serie);
          legend.data.push(serie.name);
        });
        const xAxis = {
          type: 'category',
          boundaryGap: false,
          data: []
        };
        for (let term = 1; term <= this.max_term; term++) {
          xAxis.data.push(`${term}期`);
        }
        const option = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: legend,
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          /*toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },*/
          xAxis: xAxis,
          yAxis: {
            type: 'value'
          },
          series: series
        };
        this.updateChart(option);
      },
      updateChart(option) {
        this.chart.clear();
        this.chart.setOption(option);
      },
      getAllCourseIds() {
        return this.courses.map((course) => { return course.id });
      },
      handleCheckAllCourse() {
        if (this.course_indeterminate) {
          this.checked_all_course = false;
        } else {
          this.checked_all_course = !this.checked_all_course;
        }
        this.course_indeterminate = false;

        if (this.checked_all_course) {
          this.params.course_ids = this.getAllCourseIds();
        } else {
          this.params.course_ids = [];
        }
      },
      checkCourseChange(data) {
        if (data.length === this.courses.length) {
          this.course_indeterminate = false;
          this.checked_all_course = true;
        } else if (data.length > 0) {
          this.course_indeterminate = true;
          this.checked_all_course = false;
        } else {
          this.course_indeterminate = false;
          this.checked_all_course = false;
        }
        this.updateData();
      },
      checkTypeChange() {
        if (this.params.course_data_type_ids.length > 3) {
          this.params.course_data_type_ids = this.params.course_data_type_ids.slice(1);
        }
        this.updateData();
      }
    }
  }
</script>
